[
    {
        "field": "item_description",
        "header": "Item Description"
    },
    {
        "field": "item_url",
        "header": "URL"
    },
    {
        "field": "price",
        "header": "Price Per Item"
    },
    {
        "field": "unit",
        "header": "Quantity"
    },
    {
        "field": "prcocessing_status_lkp",
        "header": "Processing Status"
    },
    {
        "field": "business_status_lkp",
        "header": "Business Status"
    },
    {
        "field": "is_active",
        "header": "Is Active"
    },
    {
        "field": "status_lkp",
        "header": "Order Status"
    },
    {
        "field": "order_number",
        "header": "Order Number"
    },
    {
        "field": "ppl_purchase_id",
        "header": "PPL Purchase ID"
    },
    {
        "field": "tracking_number",
        "header": "Tracking Number"
    },
    {
        "field": "shipping_amount",
        "header": "Shipping Amount"
    },
    {
        "field": "tax_amount",
        "header": "Tax Amount"
    },
    {
        "field": "total_amount",
        "header": "Total Amount"
    },
    {
        "field": "remarks",
        "header": "Remarks"
    }
]